h6{margin-block-start:.5em;margin-block-end:0}
/*# sourceMappingURL=business-card.component-36NECQ5V.css.map */
